import styles from './VacancyComponent.module.scss';
import Image from 'next/image';

const VacancyComponent = () => {
  return (
    <section className="container">
      <div className={styles.vacancyPage}>
        <div className={styles.vacancyPageHead}>
          <Image
            src={'/img/jobs/jobs-img1.png'}
            alt={'logo'}
            width={56}
            height={56}
          />
          <h2>Hera Flight</h2>
        </div>
        <div className={styles.vacancyPageContent}>
          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockDescription}>
              Send resumes to:{' '}
              <a
                href="mailto:careers@heraflight.com"
                className={styles.emailLink}
              >
                careers@heraflight.com
              </a>
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>Summary</div>
            <div className={styles.vacancyPageBlockDescription}>
              This position is primarily responsible for the day-to-day
              Operations including any irregular operational issues that may
              occur. The Operations Coordinator is responsible for providing
              support to departments within the Hera Company, and ensuring all
              requirements are met for the safe operation of each flight.  This
              is an in-person position at our headquarters in Clearwater, FL.
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>
              Minimum Requirements
            </div>
            <div className={styles.vacancyPageBlockDescription}>
              Combination of Education and Experience will be considered. Must
              be authorized to work in the US as defined by the Immigration Act
              of 1986. Must pass a Criminal Background Check. <br /> Education:
              High School Diploma/GED <br /> Years of Experience: Minimum one
              (1) year of airline industry experience. Minimum one (1) year of
              job experience in a Lead and/or Supervisor role in a service or
              operational position. <br />
              •Other minimum requirements: Ability to work varied shifts,
              including evenings, weekends and holidays, and be able to stay
              late for delayed flights or irregular operations in a 24/7
              environment. Ability to attend and complete required training.
              Ability to read, write, and speak English in order to receive and
              understand instructions, directives, and ensure safety, as well as
              the ability to interact with customers. High level of proficiency
              in Microsoft Office. Ability to work in a fast-paced and
              potentially high-stress environment.
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>
              Preferred Requirements
            </div>
            <div className={styles.vacancyPageBlockDescription}>
              •Bachelor’s degree (preferred but not required). <br /> •Knowledge
              and understanding of Part 91 and Part 135 operations. <br />
              •Extensive problem-solving capabilities when working with
              irregular flight operations. <br />
              •Excellent written and oral communication skills with proven
              ability to develop customer correspondence at an executive level.{' '}
              <br />
              •Highly organized, with multi-tasking ability and the ability to
              work through stressful situations. <br />
              •Team building skills and a positive attitude. <br />
              •Ability to travel if required.
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>Job Duties</div>
            <div className={styles.vacancyPageBlockDescription}>
              •Establishes and maintains positive rapport and communications via
              email and phone with all relevant departments, regulatory agencies
              and Charter-related entities. <br />
              •Communicates all information proactively and timely with the
              designated management including Executives and internal/external
              customers. <br />
              •Answers incoming calls and advises process, policy and procedures
              for all internal/external customers who contact Operations for
              guidance and assistance. <br />
              •Is responsible for working the various phases of irregular
              operations including assessment, coordination, facilitation and
              reporting of the events while working with other internal
              departments. <br />
              •Coordinates all service recovery elements with outside vendors
              which include Ad Hoc public and private charters, hotels,
              transportation companies and/or food and beverage outlets. <br />
              •Validate and balance the expenses as it relates to events in
              which they assisted in the coordination of. <br />
              •Coordinate “Positive Contact” between FBOs, and crew members per
              the Flight Crew Policy. <br /> •Maintains and updates the weekly
              fuel pricing. <br /> •Request Deice/Anti-Ice availability during
              the winter season. <br /> •Coordinates, facilitates and
              distributes international requirements for international aircraft
              movements. <br />
              •Assist with identifying potential vendors in cities where
              relationships do not exist. <br />
              •Ensure compliance with all FAA, DOT, and TSA directives and
              security requirements. <br />
              •Ensure compliance of all company policy and procedures. <br />
              •Other duties as assigned.
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>
              Physical Requirements
            </div>
            <div className={styles.vacancyPageBlockDescription}>
              The Physical Demands and Work Environment described here are
              representative of those that must be met by a Team Member to
              successfully perform the essential functions of the role.
              Reasonable accommodations may be made to enable individuals with
              disabilities to perform the essential functions of the role.{' '}
              <br /> <br />
              Office – While performing the duties of this job, the Team Member
              is regularly required to stand, sit, talk, hear, see, reach,
              stoop, kneel, and use hands and fingers to operate a computer,
              keyboard, printer, and phone. May be required to lift, push, pull,
              or carry up to 20 lbs. May be required to work various shifts/days
              in a 24-hour situation. Regular attendance is a requirement of the
              role. Exposure to moderate noise (i.e. business office with
              computers, phones, printers, and foot traffic), temperature and
              light fluctuations. Ability to work in a confined area as well as
              the ability to sit at a computer terminal for an extended period
              of time. Some travel may be a requirement of the role.
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>Hourly range</div>
            <div className={styles.vacancyPageBlockDescription}>
              $16.50-$25.00
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>
              Full Time Benefits
            </div>
            <div className={styles.vacancyPageBlockDescription}>
              Medical/Dental Insurance <br /> 401K with an employer match <br />{' '}
              Paid vacation and sick time
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VacancyComponent;
